module.exports = __webpack_public_path__ + "static/img/ys.abd639f7.png";